import { useContext } from "react"
import { Helmet } from "react-helmet-async"

import VicinityContext from "../context/vicinityContext"
import BreadCrumbs from "../components/BreadCrumbs"
import PageHeading from "../components/PageHeading"
import ComingSoon from "../components/ComingSoon"
import DashboardNotificationsCard from "../components/DashboardNotificationsCard"
import DashboardWatchlistCard from "../components/DashboardWatchlistCard"
import MobileAppBanner from "../components/MobileAppBanner"
import NewsTicker from "../components/NewsTicker"
import PlaceCard from "../components/PlaceCard"
import PlaceCardHolder from "../components/PlaceCardHolder"
import NewsCard from "../components/NewsCard"
import ReportCard from "../components/ReportCard"
import { consoleLog } from "../utilities/helpers"

export default function Index() {
    let place = useContext(VicinityContext).place
    let spotlightPlaces = useContext(VicinityContext).spotlightPlaces
    let news = useContext(VicinityContext).news
    let randomIndexes = []

    while (randomIndexes.length < spotlightPlaces.length) {
        let randomIndex = Math.floor(Math.random() * spotlightPlaces.length)
        if (!randomIndexes.includes(randomIndex)) {
            randomIndexes.push(randomIndex)
        }
    }

    // consoleLog("Index news:", news)
    consoleLog("API Server value is: ", import.meta.env.VITE_CHAPERON_API_URL)

    const filteredNews =
        news.length > 0 ? news.filter((item) => item.image !== null) : []

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{`Chaperon - We've got you covered`}</title>
            </Helmet>
            <BreadCrumbs />
            <ComingSoon />
            <div className="dashboard-container">
                <PageHeading title="Dashboard" />
            </div>
            <div>
                <div className="row row-cols-auto featurette container-fluid">
                    <div className="col-md-7">
                        {place?.name ? (
                            <PlaceCard
                                place={place}
                                currentLocation
                                mainCard={true}
                                equalHeight={false}
                            />
                        ) : spotlightPlaces.length > 0 ? (
                            <PlaceCard
                                place={spotlightPlaces[randomIndexes[0]]}
                                equalHeight={false}
                            />
                        ) : (
                            <PlaceCardHolder />
                        )}
                    </div>
                    <div className="col-md-5">
                        <DashboardNotificationsCard />
                        <DashboardWatchlistCard />
                        <MobileAppBanner />
                    </div>
                </div>

                <div className="App-content text-center pt-2 align-items-center ">
                    <div className="row">
                        <div className="col"></div>
                    </div>
                </div>

                <div className="row row-cols-1 row-cols-md-3 g-4">
                    <h1>
                        In the{" "}
                        <span className="text-body-secondary">spotlight</span>
                        ...
                    </h1>
                    <NewsTicker />
                </div>

                <div className="row row-cols-1 row-cols-md-3 g-4">
                    <div className="col">
                        {spotlightPlaces.length > 0 ? (
                            <PlaceCard
                                place={spotlightPlaces[randomIndexes[1]]}
                                mainCard={false}
                            />
                        ) : (
                            <PlaceCardHolder />
                        )}
                    </div>
                    <div className="col">
                        {filteredNews.length > 0 ? (
                            <NewsCard news={filteredNews[0]} />
                        ) : spotlightPlaces.length > 1 ? (
                            <PlaceCard
                                place={spotlightPlaces[randomIndexes[2]]}
                                mainCard={false}
                            />
                        ) : (
                            <PlaceCardHolder />
                        )}
                    </div>
                    <div className="col">
                        <ReportCard />
                    </div>
                </div>
            </div>
        </div>
    )
}
